import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Users/hooks/useUsersAndGroups.ts
var testData = {
	total: 3,
	usersAndGroups: [
		{
			color: "rgb(125,156,187)",
			id: "ID_01",
			label: "Patrol Officers",
			type: "Group"
		},
		{
			id: "ID_02",
			label: "Bob Patrolman",
			type: "User"
		},
		{
			color: "#8bdc4a",
			id: "ID_03",
			label: "Managers",
			type: "Group"
		}
	]
};
function useUsersAndGroups(args, opts = {}) {
	const { data, isCalling } = useRPC(RPCs.Users.GetUsersAndGroupsLabelsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args,
		testData
	});
	return {
		data,
		loading: isCalling
	};
}
//#endregion
export { useUsersAndGroups };

//# sourceMappingURL=useUsersAndGroups.js.map